/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What fonts are used?`)
};

const es_sig_type_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué fuentes se utilizan?`)
};

const de_sig_type_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Schriftarten werden verwendet?`)
};

const nl_sig_type_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke lettertypen worden gebruikt?`)
};

const fr_sig_type_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelles polices sont utilisées?`)
};

const it_sig_type_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali caratteri vengono utilizzati?`)
};

const pt_br2_sig_type_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais fontes são usadas?`)
};

const pt_sig_type_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que fontes são utilizadas?`)
};

const ja_sig_type_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのフォントが使用されていますか?`)
};

const zh_sig_type_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用了哪些字体？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_faq1_q", locale)
	if (locale === "en") return en_sig_type_faq1_q(inputs)
	if (locale === "es") return es_sig_type_faq1_q(inputs)
	if (locale === "de") return de_sig_type_faq1_q(inputs)
	if (locale === "nl") return nl_sig_type_faq1_q(inputs)
	if (locale === "fr") return fr_sig_type_faq1_q(inputs)
	if (locale === "it") return it_sig_type_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_faq1_q(inputs)
	if (locale === "pt") return pt_sig_type_faq1_q(inputs)
	if (locale === "ja") return ja_sig_type_faq1_q(inputs)
	return zh_sig_type_faq1_q(inputs)
};